<template>
  <div class="order-input">
    <input type="number" v-model="orderNumber" :min="minOrder" :max="maxOrder" placeholder="Number">
    <button class="green-gradient" @click="search" :disabled="!this.isValid">Rechercher</button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orderNumber: null,
      minOrder: 100000,
      maxOrder: 999999
    }
  },
  methods: {
    search () {
      if (!this.isValid) return
      this.$router.push('/order/' + this.orderNumber)
    }
  },
  computed: {
    isValid () {
      return !isNaN(this.orderNumber) && this.orderNumber >= this.minOrder && this.orderNumber <= this.maxOrder
    }
  }
}
</script>

<style lang="scss" scoped>
  .order-input {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    -webkit-display: flex;
    -webkit-flex-direction: column;
    -webkit-justify-content: space-around;
    -webkit-align-items: center;
    height: 100%;
    width: 100%;

    input, button {
      border: none;
      border-radius: 20px;
      -webkit-border-radius: 20px;
      width: 100%;
      height: 50px;
      box-shadow: 0px 0px 5px 1px darkgray;
    }

    input {
      font-size: 30px;
      text-align: center;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;

      &:focus {
        outline: none;
        box-shadow: 0px 0px 10px 1px darkgray;
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
      }
    }

    button {
      font-size: 20px;
      text-transform: uppercase;
      letter-spacing: 1.1px;
      color: white;

      &:disabled {
        background: none;
        background-color: rgb(75, 75, 75);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/scan/OrderInput.vue